import { Box } from "@mui/material";
import { subHours } from "date-fns";
import React from "react";
import { Identifier, Loading, useRecordContext } from "react-admin";
import { SiteContryEnum } from "shared/enums/globalEnums";
import GrafanaTelemetryChart from "./GrafanaTelemetryChart";

const SiteTelemetry = () => {
  const record = useRecordContext();
  if (!record) {
    return <Loading />;
  }
  return <SiteTelemetryGrafanaChart siteId={record.id} country={record.country} />;
};

type SiteTelemetryProps = {
  siteId: Identifier;
  country: SiteContryEnum;
};

export const SiteTelemetryGrafanaChart: React.FC<SiteTelemetryProps> = ({ siteId, country }) => {
  const params = React.useMemo(
    () => ({
      from: subHours(new Date(), 1).getTime(),
      to: Date.now(),
      panelId: 2,
      "var-site_id": siteId,
    }),
    [siteId],
  );

  return (
    <Box width="100%">
      <GrafanaTelemetryChart country={country} params={params} isSiteView />
    </Box>
  );
};

export default SiteTelemetry;
